import { render, staticRenderFns } from "./list-study-sessions.vue?vue&type=template&id=6ac484f2&scoped=true&"
import script from "./list-study-sessions.vue?vue&type=script&lang=ts&"
export * from "./list-study-sessions.vue?vue&type=script&lang=ts&"
import style0 from "./list-study-sessions.vue?vue&type=style&index=0&id=6ac484f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac484f2",
  null
  
)

export default component.exports